import { h } from "preact";
import tracking from "../tracking/tracking.js";

import Icon from "./Icon.jsx";
import ListItem from "./ListItem.jsx";
import TaskLink from "./TaskLink.jsx";

export default function DocumentPreviewItem({ document }) {
  function trackClick() {
    tracking.track("document.download", {
      title: document.title,
      taskIds: document.taskIds,
    });
  }

  return (
    <div class="document-preview-item">
      <div class="document-preview-item__image">
        <img src={document.thumbnail} alt="" />
      </div>
      <ListItem
        class="document-preview-item__content"
        secondLine={document.size}
        iconBack={
          <a
            class="document-preview-item__download-icon subtle"
            href={document.src}
            title={document.title}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackClick}
          >
            <Icon>file_download</Icon>
          </a>
        }
      >
        {document.title}
      </ListItem>
      {document.taskIds && (
        <div class="document-preview-item__addition">
          {document.taskIds.map((taskId) => (
            <TaskLink id={taskId} class="mr-12 mb-8" />
          ))}
        </div>
      )}
    </div>
  );
}
